// extracted by mini-css-extract-plugin
export default {"button":"Competence_button__wQ4hG","checked":"Competence_checked__isRFq","normal":"Competence_normal__Q7C5b","text":"Competence_text__Mob0Y","counter":"Competence_counter__R1myI"};